module.exports = __webpack_public_path__ + "static/sport/btn-register.59a39e3.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/new-sport/btn-register.webp
// module id = vu5T
// module chunks = 0